/**
 * Gets display name for a component.
 * Commonly used by an HOC component.
 */
const getDisplayName = (WrappedComponent: React.ComponentType) => {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}

export default getDisplayName
